var _path, _mask, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniGymResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M16.17 20.822l2.85 2.85 4.561-4.56-2.85-2.851-4.561 4.56zM29.074 20.042c.788-.788.788-2.064 0-2.85l-6.423-6.424c-.787-.787-2.063-.787-2.85 0-.788.788-.788 2.064 0 2.85l6.423 6.424c.786.788 2.063.788 2.85 0zM19.952 29.165c.787-.788.787-2.064 0-2.851l-6.424-6.423c-.786-.788-2.063-.788-2.85 0-.788.787-.788 2.064 0 2.85l6.423 6.424c.787.787 2.063.787 2.85 0z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "r2i86uo9ta",
    width: 7,
    height: 7,
    x: 24,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.964 9.091h5.938v5.938h-5.938V9.091z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#r2i86uo9ta)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M28.303 14.71l-3.02-3.019c-.425-.426-.425-1.117 0-1.543l.739-.737c.426-.427 1.117-.427 1.542 0l3.019 3.019c.425.425.425 1.116 0 1.542l-.738.738c-.426.426-1.117.426-1.542 0z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M12.338 30.674l-3.019-3.018c-.425-.427-.425-1.118 0-1.543l.739-.739c.425-.425 1.117-.425 1.542 0l3.019 3.019c.425.427.425 1.117 0 1.544l-.739.737c-.425.425-1.116.425-1.542 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniGymResting);
export default __webpack_public_path__ + "static/media/icon_mini_gym_resting.9810ae22ae954f6b346b0c104a96bed2.svg";
export { ForwardRef as ReactComponent };